<svg
    [style.width.px]="size"
    [style.height.px]="size"
    [attr.x]="0"
    [attr.y]="0"
    [attr.viewBox]="'0 0 40 40'"
    class="spinner">
    <circle cx="20" cy="20" r="18" [ngStyle]="{stroke: color}"></circle>
</svg>
